import { NgModule } from '@angular/core';
import { FiservPosPaymentComponent } from './components/fiserv-pos-payment/fiserv-pos-payment.component';
import { FiservPosDevicesComponent } from './components/fiserv-pos-devices/fiserv-pos-devices.component';

/**
 * Import this module to use <fiserv-pos-payment> and <fiserv-pos-devices> in a
 * template-based (NgModule) context.
 *
 * For standalone components, import FiservPosPaymentComponent or
 * FiservPosDevicesComponent directly from '@cmbsolutions/fiserv-angular'.
 */
@NgModule({
  imports: [FiservPosPaymentComponent, FiservPosDevicesComponent],
  exports: [FiservPosPaymentComponent, FiservPosDevicesComponent],
})
export class FiservPosModule {}
